import { Vue, Component } from "vue-property-decorator";
import ControlCusPlan from '@/modules/cavite-edit/components/ems/control-plan';
import { State } from 'vuex-class';
import CavCavite from '@/lib/models/cav-cavite';
import ControlCavPhotos from '@/modules/cavite-edit/components/control-photos';
import ControlCavDocuments from '@/modules/cavite-edit/components/control-documents';

@Component
export default class PartEmsDocPlans extends Vue {

  @State(s => s.caviteEdit.editedCavite) data: CavCavite;

  render() {
    return (
      <div class="main-tab-inner">
        <div class="columns">
          <div class="column is-12">
            <div class="field">
              <label class="label is-small">Plans</label>
              <ControlCusPlan collection={this.data.cus.plans} />
            </div>
            <div class="field">
              <label class="label is-small">Photos</label>
              <ControlCavPhotos collection={this.data.photos} />
            </div>
            <div class="field">
              <label class="label is-small">Documents</label>
              <ControlCavDocuments collection={this.data.documents} />
            </div>
          </div>
        </div>
      </div>
    );
  }

}
// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-0a20a76a/doc-plans.tsx" });